






import Vue from "vue"

export default Vue.extend({
  name: "BaseMoney",
  props: {
    amount:   { type: [String, Number], default: null },
    currency: { type: String, default: 'EUR' },
    decimalPlaces: { type: Number, default: 2 },
    signed:   { type: Boolean, default: false },
  },
  computed: {
    symbol() {
      return {
        'EUR': '€',
        'USD': '$',
        'GBP': '£',
      }[this.currency] || ''
    },
    fixed() {
      return Number.parseFloat(this.amount).toFixed(this.decimalPlaces)
    },
    formatted(): string {
      if (this.amount == null) {
        return ""
      }
      const val = Number.parseFloat(this.amount).toFixed(this.decimalPlaces).replace('.', ',')
      let formatted = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
      if (this.signed && this.amount > 0) {
        formatted = `+${formatted}`
      }
      return formatted + ' ' + this.symbol
    },
    color() {
      if (this.amount > 0) {
        return 'green--text'
      } else if (this.amount == 0) {
        return 'grey--text'
      }
      return 'red--text'
    },
  },
})
